import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Heading, Span, Stack, useBreakpointValue, } from '@chakra-ui/react';
import { OrderPage } from '@client/pages/OrderPage';
import { displayFontFamily } from '@client/theme';
import { useParams } from 'react-router-dom';
export const OrderIsolatedPage = () => {
    const { shortId } = useParams();
    const isDesktop = useBreakpointValue({ base: false, md: true });
    return (_jsxs(Stack, { p: 5, gap: 5, width: "fit-content", ...(isDesktop && { mx: 'auto', mt: 5, minWidth: 600 }), children: [_jsxs(Heading, { fontSize: 36, fontWeight: 400, fontFamily: displayFontFamily, children: ["Order #", _jsx(Span, { fontWeight: 500, children: shortId })] }), _jsx(OrderPage, {})] }));
};
